import * as Progress from '@radix-ui/react-progress';

type LimitProgressProps = {
  used: number;
  limit: number;
};

export function LimitProgress({ used, limit }: LimitProgressProps) {
  const value = Math.min((used / limit) * 100, 100);

  return (
    <Progress.Root
      className="relative h-[1.6rem] w-full overflow-hidden rounded-4xl bg-secondary-bg"
      value={value}>
      <Progress.Indicator
        className="h-full w-full rounded-4xl bg-cyan transition-transform duration-300"
        style={{ transform: `translateX(-${100 - value}%)` }}
      />
    </Progress.Root>
  );
}
